import { css } from '@emotion/core';

export const colorsCss = css`
  :root {
    // Primary
    --color-indigo: #4140a4;
    --color-indigo-70: #4140a4b3;
    --color-indigo-50: #4140a480;
    --color-indigo-30: #4140a44d;
    --color-indigo-10: #4140a41a;
    --color-indigo-t0: #f7f7fa;
    --color-indigo-t1: #d9d9ed;
    --color-indigo-t2: #c0bfe1;
    --color-indigo-t3: #a09fd1;
    --color-indigo-t4: #8080c2;
    --color-indigo-t5: #6160b3;
    --color-indigo-t6: #4140a4;
    --color-indigo-t7: #363589;
    --color-indigo-t8: #2b2b6d;
    --color-indigo-t9: #202052;
    --color-indigo-t10: #161537;
    --color-indigo-t11: #0d0d21;

    // Secondary
    --color-vibrant-blue: #1ccbd7;
    --color-vibrant-blue-70: #1ccbd7b3;
    --color-vibrant-blue-50: #1ccbd780;
    --color-vibrant-blue-30: #1ccbd74d;
    --color-vibrant-blue-10: #1ccbd71a;
    --color-vibrant-blue-t0: #e8fafb;
    --color-vibrant-blue-t1: #d2f5f7;
    --color-vibrant-blue-t2: #b3eef2;
    --color-vibrant-blue-t3: #8de5eb;
    --color-vibrant-blue-t4: #68dce4;
    --color-vibrant-blue-t5: #42d4de;
    --color-vibrant-blue-t6: #1ccbd7;
    --color-vibrant-blue-t7: #17a9b3;
    --color-vibrant-blue-t8: #13878f;
    --color-vibrant-blue-t9: #0e656b;
    --color-vibrant-blue-t10: #094448;
    --color-vibrant-blue-t11: #06292b;

    // Accent
    --color-lime: #ddf33f;
    --color-lime-70: #ddf33fb3;
    --color-lime-50: #ddf33f80;
    --color-lime-30: #ddf33f4d;
    --color-lime-10: #ddf33f1a;
    --color-lime-t0: #fcfeec;
    --color-lime-t1: #f8fdd9;
    --color-lime-t2: #f4fbbf;
    --color-lime-t3: #eef99f;
    --color-lime-t4: #e8f77f;
    --color-lime-t5: #e3f55f;
    --color-lime-t6: #ddf33f;
    --color-lime-t7: #b8ca34;
    --color-lime-t8: #93a22a;
    --color-lime-t9: #6e791f;
    --color-lime-t10: #4a5115;
    --color-lime-t11: #2c310d;

    // Error / Warning
    --color-coral: #f4675b;
    --color-coral-70: #f4675bb3;
    --color-coral-50: #f4675b80;
    --color-coral-30: #f4675b4d;
    --color-coral-10: #f4675b1a;
    --color-coral-t0: #fef0ef;
    --color-coral-t1: #fde1de;
    --color-coral-t2: #fbccc8;
    --color-coral-t3: #f9b3ad;
    --color-coral-t4: #f89a92;
    --color-coral-t5: #f68076;
    --color-coral-t6: #f4675b;
    --color-coral-t7: #cb564c;
    --color-coral-t8: #a3453d;
    --color-coral-t9: #7a332d;
    --color-coral-t10: #51221e;
    --color-coral-t11: #311512;

    // Background colours
    --color-b0: #f9f9fc;
    --color-b1: #fcfcfc;
    --color-extra-white: #ffffff;
    --color-modal-bg: #0d0d21cc;

    // Additional
    --color-amber: #ff8a00;
  }
`;
